/* eslint-disable camelcase */

import type { IssuesMap } from '../../common/utils/use-issues-map';
import type { TimelineViewIssue } from '../get-timeline-view-issues/types';
import type { RemoveJWMDependencyTimelineView_unlinkJwmItems } from './__generated_apollo__/RemoveJWMDependencyTimelineView';

export const createOptimisticLinkItems = ({
	linkId,
	issuesMap,
}: {
	linkId: string;
	issuesMap: IssuesMap;
}): RemoveJWMDependencyTimelineView_unlinkJwmItems => {
	// linked issues
	const [inwardIssue, outwardIssue] = Array.from(issuesMap.values()).filter(
		(issue) =>
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			!!(issue as TimelineViewIssue).originalIssueLinks.find(
				(edge) => edge.node?.issueLinkId === linkId,
			),
	);

	return {
		inwardItem: {
			issueId: Number(inwardIssue?.issueId),
			issueLinks: {
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				edges: (inwardIssue as TimelineViewIssue)?.originalIssueLinks.filter(
					(edge) => edge.node?.issueLinkId !== linkId,
				),
				__typename: 'JiraIssueLinkConnection',
			},
			__typename: 'JiraWorkManagementViewItem',
		},
		outwardItem: {
			issueId: Number(outwardIssue?.issueId),
			issueLinks: {
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				edges: (outwardIssue as TimelineViewIssue)?.originalIssueLinks.filter(
					(edge) => edge.node?.issueLinkId !== linkId,
				),
				__typename: 'JiraIssueLinkConnection',
			},
			__typename: 'JiraWorkManagementViewItem',
		},
		success: true,
		errors: null,
		__typename: 'JWMUnlinkItemsPayload',
	};
};
